import axiosInstance from './axiosInstance';

export const fetchPortfolioSummary = async (accounts = '', periodParams = {}) => {
  const res = await axiosInstance.get('/portfolio/summary', {
    params: { ...(accounts ? { accounts } : {}), ...periodParams },
  });
  return res.data;
};

export const fetchPeriodChart = async (accounts = '', periodParams = {}) => {
  const res = await axiosInstance.get('/portfolio/period-chart', {
    params: { ...(accounts ? { accounts } : {}), ...periodParams },
  });
  return res.data;
};

export const fetchProfitComposition = async (accounts = '', periodParams = {}) => {
  const res = await axiosInstance.get('/portfolio/profit-composition', {
    params: { ...(accounts ? { accounts } : {}), ...periodParams },
  });
  return res.data;
};

export const fetchSectorRatio = async (accounts = '') => {
  const res = await axiosInstance.get('/portfolio/sector-ratio', {
    params: accounts ? { accounts } : {},
  });
  return res.data;
};

export const fetchPortfolioHoldings = async (accounts = '') => {
  const res = await axiosInstance.get('/portfolio/holdings', {
    params: accounts ? { accounts } : {},
  });
  return res.data;
};

export const fetchPortfolioTrend = async (accounts = '', period = 12) => {
  const res = await axiosInstance.get('/portfolio/monthly-trend', {
    params: { period, ...(accounts ? { accounts } : {}) },
  });
  return res.data;
};

export const fetchHoldingsDetail = async (accounts = '') => {
  const res = await axiosInstance.get('/portfolio/holdings-detail', {
    params: accounts ? { accounts } : {},
  });
  return res.data;
};

export const fetchPeriodDetail = async (accounts = '', periodParams = {}) => {
  const res = await axiosInstance.get('/portfolio/period-detail', {
    params: { ...(accounts ? { accounts } : {}), ...periodParams },
  });
  return res.data;
};

export const fetchPeriodEval = async (accounts = '', periodParams = {}) => {
  const res = await axiosInstance.get('/portfolio/period-eval', {
    params: { ...(accounts ? { accounts } : {}), ...periodParams },
  });
  return res.data;
};
